import { useState } from "react";
// import "pages/departments/Departments.css";
import "./Departments.css";

const data = {
  org: "Zilla Parishad Pune",
  title: "Gram Panchayat Division",
  titleMarathi: "ग्रामपंचायत विभाग",
  established: "1 May 1961",
  emblem: "🏛️",
  intro: `The 73rd amendment of the Indian Constitution intended to make Gram Panchayats self-reliant and empower them as autonomous institutions. Pune district is divided into 13 Development Blocks and 1386 Gram Panchayats. Various government schemes are implemented through Gram Panchayat, Block, and Zilla Parishad to bring the benefits of development to grassroots rural people — with a special focus on uplifting backward classes and below-poverty-line families.`,
  stats: [
    { value: "1386", label: "Gram Panchayats" },
    { value: "32.58L", label: "Total Rural Population" },
    { value: "13", label: "Development Blocks" },
    { value: "15,642", label: "Rural Area (sq. km)" },
    { value: "961", label: "GP Officers" },
    { value: "35", label: "Extension Officers" },
  ],
  info: [
    { key: "Established", val: "1 May 1961" },
    { key: "Total GPs", val: "1386" },
    { key: "Blocks", val: "13" },
    { key: "SC Population", val: "2,43,580" },
    { key: "ST Population", val: "2,03,838" },
    { key: "PESA GPs", val: "84 (2 Blocks)" },
    { key: "Revenue Demand", val: "₹62,155.37 Lakhs" },
    { key: "Property Tax", val: "₹54,588.06 Lakhs" },
    { key: "Water Tax", val: "₹7,567.31 Lakhs" },
  ],
  contact: [
    { icon: "📞", label: "020-26131984" },
    { icon: "🏢", label: "District Level Office" },
    { icon: "🏛️", label: "Zilla Parishad Pune" },
  ],
  services: [
    "Property Tax Collection",
    "Water Tax Collection",
    "Gram Panchayat Registration",
    "Scheme Implementation",
    "Sarpanch Awards",
    "Gramsevak Awards",
    "PESA Area Management",
    "Smart Village Program",
  ],
  pesa: {
    title: "PESA Act Coverage",
    text: "Under PESA Act 1996, there are 37 Gram Panchayats in Ambegaon Block and 47 in Junnar Block — totalling 84 GPs across 2 blocks, covering 150 revenue villages.",
  },
  schemes: [
    {
      name: "Jan Suvidha Yojana",
      desc: "Grants for cremation/burial grounds, GP offices, intra-village roads, weekly markets, pond desilting, solid waste management, underground sewer, and solar hand pumps.",
      amount: "₹15–20 Lakhs per work",
    },
    {
      name: "Nagri Suvidha Yojana",
      desc: "For GPs with population above 3,000. Provides up to ₹2 Crore/year and ₹5 Crore in project years. 90% funded by District Planning Committee, 10% by GP.",
      amount: "Up to ₹2–5 Crore",
    },
    {
      name: "'C' Class Pilgrimage Areas",
      desc: "Works include toilets, bathrooms, water supply, devotees accommodation, street lights, area improvement, parking lots, ghat construction, and paving blocks in pilgrimage areas.",
      amount: "GR dt. 16 Nov 2012",
    },
    {
      name: "Central Finance Commission (15th FC)",
      desc: "60% for tied works (30% solid waste, 30% water supply), 40% for untied works including roads, gutters, paving blocks, schools, anganwadis, solar panels, and welfare schemes.",
      amount: "FY 2020–2026",
    },
    {
      name: "Majhi Vasundhara Abhiyan 5.0",
      desc: "Environment protection campaign based on five elements of nature. Awards given to best-performing local bodies for green areas, water conservation, and renewable energy.",
      amount: "Environment Awards",
    },
    {
      name: "Rashtriya Gramswaraj Abhiyan",
      desc: "Training & capacity building of GPs, digital technology adoption, e-GramSwaraj portal. Includes construction of GP offices and CSC centers in PESA areas.",
      amount: "Central Scheme",
    },
    {
      name: "Balasaheb Thackeray Smriti Matoshree Gramsachivalay",
      desc: "Grant provided to build new Gram Panchayat office buildings across the district.",
      amount: "₹20–25 Lakhs",
    },
    {
      name: "PM Vishwakarma",
      desc: "Financial & technical assistance to 18 types of traditional artisans. Free skill training and concessional loans at 5% interest rate. GP-level outreach and market linkage.",
      amount: "₹1L (Phase 1) / ₹2L (Phase 2)",
    },
    {
      name: "R(Aba) Patil Sundar Gaon Puraskar (Smart Village)",
      desc: "One taluka smart village per taluka, and one district smart village from 13 selected. Focus on natural resources, environment balance, and inter-departmental scheme coordination.",
      amount: "₹10L (Taluka) / ₹40L (District)",
    },
    {
      name: "Rajarshi Shahu Maharaj Senior Literary & Artist Yojana",
      desc: "Financial honor to senior artists/literary persons aged 50+, annual income below ₹48,000, with 15+ years in arts. 100 artists selected per year at district level.",
      amount: "₹5,000/month",
    },
    {
      name: "Adarsh Sarpanch / Gramsevak Award",
      desc: "Annual award on Gandhi Jayanti (2nd Oct). One gramsevak per block and one sarpanch per 13 blocks selected. Tribal sarpanch award for Junnar, Ambegaon, Khed & Maval.",
      amount: "Since 1997–98",
    },
  ],
  tabs: ["Overview", "Schemes", "Statistics", "Services", "Contact"],
};

export default function GramPanchayatVibhag() {
  const [activeTab, setActiveTab] = useState("Overview");

  return (
    <div>
      {/* Top Strip */}
      <div className="dept-top-strip">
        <span>🏛️ Zilla Parishad Pune — Official Department Portal</span>
        <span>📅 Est. {data.established}</span>
      </div>

      {/* Header */}
      <div className="dept-header">
        <div className="dept-header-emblem">{data.emblem}</div>
        <div className="dept-header-text">
          <div className="dept-header-org">{data.org}</div>
          <div className="dept-header-title">{data.title}</div>
          <div className="dept-header-subtitle">{data.titleMarathi}</div>
        </div>
        <div className="dept-header-badge">Est. {data.established}</div>
      </div>

      {/* Nav Tabs */}
      <div className="dept-nav">
        {data.tabs.map((tab) => (
          <button
            key={tab}
            className={`dept-nav-tab ${activeTab === tab ? "active" : ""}`}
            onClick={() => setActiveTab(tab)}
          >
            {tab}
          </button>
        ))}
      </div>

      {/* Main Content */}
      <div className="dept-main">

        {/* Intro Hero */}
        <div className="dept-intro">
          <div className="dept-intro-label">About the Division</div>
          <div className="dept-intro-text">
            {data.intro} <br /><br />
            <strong>PESA Coverage:</strong> {data.pesa.text}
          </div>
        </div>

        {/* Stats Row */}
        <div className="dept-stats">
          {data.stats.map((s, i) => (
            <div className="dept-stat-card" key={i}>
              <div className="dept-stat-value">{s.value}</div>
              <div className="dept-stat-label">{s.label}</div>
            </div>
          ))}
        </div>

        {/* Schemes Section */}
        <div className="dept-section">
          <div className="dept-section-header">
            <div className="dept-section-icon">📋</div>
            <div className="dept-section-title">Government Schemes</div>
          </div>
          <div className="scheme-list">
            {data.schemes.map((scheme, i) => (
              <div className="scheme-card" key={i}>
                <div className="scheme-card-name">{scheme.name}</div>
                <div className="scheme-card-desc">{scheme.desc}</div>
                <span className="scheme-card-amount">{scheme.amount}</span>
              </div>
            ))}
          </div>
        </div>

        {/* Sidebar */}
        <div className="dept-sidebar">

          {/* Department Info */}
          <div className="dept-info-card">
            <div className="dept-info-card-title">Department Details</div>
            {data.info.map((row, i) => (
              <div className="dept-info-row" key={i}>
                <span className="dept-info-key">{row.key}</span>
                <span className="dept-info-val">{row.val}</span>
              </div>
            ))}
          </div>

          {/* PESA Highlight */}
          <div className="dept-info-card">
            <div className="dept-info-card-title">PESA Special Area</div>
            <div className="dept-highlight-box">
              <div className="dept-highlight-box-title">⚖️ {data.pesa.title}</div>
              <p>{data.pesa.text}</p>
            </div>
          </div>

          {/* Services */}
          <div className="dept-info-card">
            <div className="dept-info-card-title">Key Services</div>
            <div className="dept-services-grid">
              {data.services.map((s, i) => (
                <div className="dept-service-item" key={i}>{s}</div>
              ))}
            </div>
          </div>

          {/* Contact */}
          <div className="dept-contact-card">
            <div className="dept-contact-card-title">Contact Information</div>
            {data.contact.map((c, i) => (
              <div className="dept-contact-row" key={i}>
                <span>{c.icon}</span>
                <span>{c.label}</span>
              </div>
            ))}
          </div>

        </div>
      </div>

      {/* Footer */}
      <div className="dept-footer">
        <strong>Zilla Parishad Pune</strong> — Gram Panchayat Division &nbsp;|&nbsp; Est. 1 May 1961 &nbsp;|&nbsp; Telephone: 020-26131984
      </div>
    </div>
  );
}